import graphql__cabcefc15a15a7b4064d from "./__generated__/Report_reportable.graphql.js";import { useCallback, useRef, useState } from "react";
import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";
import classNames from "classnames";

import Button from "../Buttons/Button";
import { useFormatMessage } from "../Intl/Context";
import { report } from "../../mutations/ReportMutation";
import Tooltip from "../Tooltip/Tooltip";
import { useAlert } from "../Alerts/withAlert";
import { ALERT_TYPE_ERROR, ALERT_TYPE_SUCCESS } from "../Alerts/Alert";
import ConfirmationModal from "../Modals/ConfirmationModal";

const Report = props => {
  const reportable = useFragment(Report_reportable, props.reportable);
  const { id } = reportable;
  const { showAlert } = useAlert();

  const [isLoading, setIsLoading] = useState(false);
  const openConfirmModalRef = useRef(() => {});
  const closeConfirmModalRef = useRef(() => {});

  const t = useFormatMessage();
  const reportTooltipContent = t(intlMessages.reportTooltipContent);
  const reportTitle = t(intlMessages.reportTitle);
  const successMessage = t(intlMessages.successMessage);
  const reportQuestion = t(intlMessages.reportQuestion);

  const handleReportResponse = useCallback(
    ({ report: { success, notice } }) => {
      if (success) {
        showAlert({ message: successMessage, type: ALERT_TYPE_SUCCESS });
        setIsLoading(false);
        closeConfirmModalRef.current && closeConfirmModalRef.current();
      } else {
        showAlert({ message: notice, type: ALERT_TYPE_ERROR });
      }
    },
    [showAlert, successMessage]
  );

  const handleButtonClicked = useCallback(() => {
    openConfirmModalRef.current && openConfirmModalRef.current();
  }, []);

  const handleConfirmButtonClicked = useCallback(() => {
    setIsLoading(true);
    report(id, handleReportResponse);
  }, [handleReportResponse, id]);

  const className = classNames(
    "btn-unstyled",
    "text-btn-lg",
    "text-primary",
    props.className
  );

  return (
    <>
      <Tooltip content={reportTooltipContent} placement="right">
        <Button
          type="button"
          screenReaderLabel={reportTitle}
          className={className}
          onClick={handleButtonClicked}
          iconClassName="fa fa-flag"
        />
      </Tooltip>

      <ConfirmationModal
        title={reportTitle}
        message={reportQuestion}
        confirmButtonLabel={reportTitle}
        openRef={openConfirmModalRef}
        closeRef={closeConfirmModalRef}
        onConfirm={handleConfirmButtonClicked}
        closeOnConfirm={false}
        isLoading={isLoading}
      />
    </>
  );
};

const Report_reportable = graphql__cabcefc15a15a7b4064d;

export default Report;

const intlMessages = defineMessages({
  reportQuestion: {
    id: "report.reportQuestion",
    defaultMessage: "Êtes-vous sure de vouloir signaler ce contenu ?"
  },
  reportTitle: {
    id: "report.reportTitle",
    defaultMessage: "Signaler"
  },
  successMessage: {
    id: "report.successMessage",
    defaultMessage: "Signalement effectué"
  },
  reportTooltipContent: {
    id: "report.reportTooltipContent",
    defaultMessage: "Signaler un contenu inapproprié"
  }
});
